<div mat-dialog-title class="heading">Comments</div>
    <div *ngIf="userComments">
        <div class="card">
            <mat-tree class="mt-4" [dataSource]="userComments" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node class="mt-1 card-body" *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <div style="width : 100%" class="row">
                        <button class="col-1" mat-icon-button disabled></button>
                        <span class="col-11">
                            <strong>{{node.comment_by}}</strong> <br> {{node.comment}}
                            <mat-icon style="float:right;" (click)="replyToComment(node)">reply</mat-icon>
                        </span>

                    </div>
                    <div style="width:100%" *ngIf="commentToReply && node.id==commentToReply.id"><br>
                        <form #replyForm="ngForm" (ngSubmit)="reply()">
                            <div class="ml-4">
                                <textarea placeholder="Reply to {{node.comment_by}}" name="replyBox" class="reply" [(ngModel)]="replyComment" required></textarea>
                                <mat-icon style="margin-top: -0.3em;transform: scale(.75);margin-left: 0.5em;" (click)="replyCancel()">clear</mat-icon>
                            </div>
                            <mat-icon (click)="reply()" style="padding-left: 0.5em;" title="Reply" [disabled]="!replyForm.valid" type="submit">send</mat-icon>
                            <br>
                        </form>
                    </div>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node class="mt-1 card-body" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                    <div style="width : 100%" class="row">
                        <!-- <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle class = "col-1"
        [attr.aria-label]="'toggle ' + node.comment">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon> -->
                        <button class="col-1" mat-icon-button disabled></button>

                        <span class="col-11">
                    <strong>{{node.comment_by}}</strong> <br> {{node.comment}} <br>

                    <a type="button" class="mt-1" class="mat-icon-rtl-mirror" style="color:blue;
          text-decoration:underline;" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.comment">
                        <a *ngIf="treeControl.isExpanded(node)">Hide Replies</a>
                        <a *ngIf="!treeControl.isExpanded(node) ">Show Replies</a>
                    </a>
                    <mat-icon (click)="replyToComment(node)" style="float:right;">reply</mat-icon>
                </span>
                    </div>

                    <div style="width:100%" *ngIf="commentToReply && node.id==commentToReply.id"><br>
                        <form #replyForm="ngForm" (ngSubmit)="reply()">
                            <div class="ml-4 ">
                                <textarea placeholder="Reply to {{node.comment_by}}" name="replyBox" class="reply" [(ngModel)]="replyComment" required></textarea>
                                <mat-icon style="margin-top: -0.3em;transform: scale(.75);margin-left: 0.5em;" (click)="replyCancel()">clear</mat-icon>
                            </div>
                            <mat-icon (click)="reply()" style="padding-left: 0.5em;" title="Reply" [disabled]="!replyForm.valid" type="submit">send</mat-icon>
                            <br>
                        </form>
                    </div>
                </mat-tree-node>
            </mat-tree>
        </div>
    </div>

    <div class="mt-1">
        <form #commentForm="ngForm">
            <textarea name="commentBox" placeholder="Add Comment" class="col-12" style="font-size: 14px;" [(ngModel)]="comment" required></textarea>
            <button mat-raised-button class="back-button" (click)="back()" mat-raised-button>Back</button>
            <button mat-raised-button [disabled]="!commentForm.valid" (click)=addComment()>Add Comment</button>
        </form>
    </div>